(($) => {
  const repSearchContainer = document.querySelector('[data-live-rep-search]');
  if(repSearchContainer) {
    const repSearchForm = repSearchContainer.querySelector('[data-live-rep-search-form]');
    const repSearchField = repSearchContainer.querySelector('[data-live-rep-search-input]');
    const repContentField = repSearchContainer.querySelector('[data-live-rep-content]');

    function handleRepSearch(event) {
      event.preventDefault();

      const zip = repSearchField.value;
      $.ajax({
          url: "/apps/api/get_agent",
          type: "get",
          data: { zip: zip },
          error: function(err) {
            displayContent(err.responseJSON);
          }
      }).done(function(res) {
        displayContent(res);
      });

    }

    function displayContent(res) {
      repContentField.innerHTML = "";
      if(res.message) {
        repContentField.innerHTML = `<p class="find-rep-response-message">${res.message}</p>`;
      } else {
        var agent = res.agent;
        var linkRegEx = /^(https?:\/\/)/g
        var { website } = agent;
        if (!linkRegEx.test(website))
          website = 'http://' + website;
      
        repContentField.innerHTML = `<div class="company-name">${agent.company_name}</div>
          <div class="address">${agent.address}</div>
          <div><span class="city">${agent.city}</span>, <span class="state-code">${agent.state_code}</span></div>
          <div class="zip">${agent.company_zip}</div>

          <div class="country">${agent.country}</div>
          <div> <span class="telephone">${agent.phone}</span></div>`+
          ((agent.website)?`<div><a class="website" href="${new URL(website)}">${agent.website}</a></div>`:'')+
          ((agent.description)?`<div class="description">${agent.description}</div>`:'');
      }
    }

    repSearchForm.addEventListener('submit', handleRepSearch);
  }
})($ = jQuery);
